
import axios from "axios";

const API_URL = "";

export const getConversations = (smtpId) =>
  axios.get(`${API_URL}/conversations/${smtpId}`);

export const getMessages = (conversationId) =>
  axios.get(`${API_URL}/conversations/messages/${conversationId}`);

// Удалить контакт из базы
export const deleteContact = async (smtpId, email) => {
  return await axios.delete(
    `${API_URL}/conversations/${smtpId}/contact/${encodeURIComponent(email)}`
  );
};